import { AppConstants } from '@shared/core';
import { environment } from '../../../environments/environment';

export const appConstants: AppConstants = {
    environment: environment,
    environmentConfigUrl: 'assets/environment-config/environment-config.json',
    joinDuplicatedSlotsAndTakeFirst: true,
    maxConcurrentRequests: 20,
    numOfFreeSlotsPerRequest: 500,
    defaultFreeSlotsToDateAddition: 3,
    noAuthHeader: 'NoAuth',
    externalUrls: {
        medifit: 'https://www.medifit.si/',
    },
    defaultDateFormat: 'YYYY-MM-DD',
    matomo: {
        siteId: 32,
        trackerUrl: 'https://data.medifit.si/',
    },
    styleLoader: {
        styleSheetId: 'mainStylesheet',
    },
    authJwtInterceptor: {
        accessTokenIgnoreUrl: '/token/',
        refreshTokenIgnoreUrl: '/refresh/',
    },
    applicationTypeCookieName: 'mcl-application',
    redirectAfterLoginParameter: 'redirectAfterLogin',
    httpClient: {
        authBase: '/auth/v2',
        authBaseV1: '/booking',
        settingsBase: '/mca/settings',
        mcaBase: '/mca',
        legacyMedicalBase: '/medical',
        customersBase: '/mca/customers',
        bookingV2: '/booking/api/v2',
        patientApiBase: '/booking/patient/api',
    },
    appTypeTranslations: {},
};
